import * as THREE from "three";
import { ControlContext } from "../ControlContext";
import { useContext, useEffect, useRef } from "react";
import { useLoader } from "@react-three/fiber";
import { TextureLoader } from "three/src/loaders/TextureLoader";
import { withCrossOrigin } from "../utils/ensureTextureCrossOrigin";

export default function SimpleWall() {
  const { wallColor } = useContext(ControlContext);
  const shadowMap = useLoader(
    TextureLoader,
    "/models/WALL copy3.webp",
    withCrossOrigin
  );
  const normalMap = useLoader(
    TextureLoader,
    // "/textures/others/plaster/GSG_MC001_A104_DDrywall01/GSG_MC001_A104_DDrywall01_4k_normal.jpg"
    "/textures/others/Plaster1/plaster_normal.jpg",
    withCrossOrigin
  );
  const roughnessMap = useLoader(
    TextureLoader,
    // "/textures/others/plaster/GSG_MC001_A104_DDrywall01/GSG_MC001_A104_DDrywall01_4k_roughness.jpg"
    "/textures/others/Plaster1/plaster_gloss.jpg",
    withCrossOrigin
  );
  const wallRef = useRef();

  useEffect(() => {
    if (wallRef.current) {
      wallRef.current.traverse((child) => {
        if (child.isMesh) {
          child.userData.isEnvironment = true;
        }
      });
    }
  }, []);

  // Set up texture repeat for normal and roughness maps
  useEffect(() => {
    const repeatY = 2;
    const repeatX = 3.57;

    normalMap.wrapS = normalMap.wrapT = THREE.RepeatWrapping;
    normalMap.repeat.set(repeatX, repeatY);

    roughnessMap.wrapS = roughnessMap.wrapT = THREE.RepeatWrapping;
    roughnessMap.repeat.set(repeatX, repeatY);

  }, [normalMap, roughnessMap]);

  return (
    <>
      <mesh ref={wallRef} position={[0, -20, 0]} receiveShadow>
        <planeGeometry args={[500, 280]} />
        <meshStandardMaterial
          color={wallColor}
          map={shadowMap}
          envMapIntensity={0}
          normalMap={normalMap}
          normalScale={[2, 2]}
          roughnessMap={roughnessMap}
          roughness={2}
        />
      </mesh>
    </>
  );
}
